



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { RowConfig } from '@/lib/RowConfig.interface'
import { Locale, LocaleDict, GenerateLocaleDict } from '@/lib/Locale'
import { query as tenant } from '@/store/tenant'
import { tenantLocales } from '@/i18n'
// @ts-ignore
// Source: https://stackoverflow.com/a/6491621
function findInObject(object, searchString) {
    searchString = searchString.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    searchString = searchString.replace(/^\./, '');           // strip a leading dot
    const keyArray = searchString.split('.');
    for (var i = 0, n = keyArray.length; i < n; ++i) {
        const key = keyArray[i];
        if (key in object) {
            object = object[key];
        } else {
            return;
        }
    }
    return object;
}

@Component<Editor>({
  // @ts-ignore
  apollo: {
    tenant
  }
})
export default class Editor extends Vue {
  @Prop()
  rows!: RowConfig[]

  @Prop()
  model!: { [key: string]: LocaleDict }

  language = Locale.German
  previewLanguage = Locale.German

  @Prop()
  isPreviewVisible!: boolean

  quillOptions = {
    modules: {
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['link'],
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['clean']
      ]
    }
  }

  fromKey(model: any, key: string | string[], offset = 0): LocaleDict {
    if (typeof key === 'string') return findInObject(model, key)
    else if (offset + 1 >= key.length) return model[key[offset]]
    else return this.fromKey(model[key[offset]], key, offset + 1)
  }

  get isRtl() {
    return this.language == "ar"
  }

  get languages() {
    const lang = []
    // @ts-ignore
    const allowedList = tenantLocales[this.tenant?.id.split("-")[1]] || []
    for (const key in Locale) {
      // @ts-ignore
      if(!allowedList.includes(Locale[key])) { continue; }
      lang.push({
        value: Locale[key as keyof typeof Locale],
        text: this.$t(`locale.${Locale[key as keyof typeof Locale]}`)
      })
    }
    return lang
  }

  @Watch('model')
  async scrollReset() {
    await this.$nextTick()
    window.scrollTo(0, 0)
  }
}
